"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetallicAsteroid = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const SpaceBonus_1 = require("../../SpaceBonus");
const SpaceType_1 = require("../../SpaceType");
const TileType_1 = require("../../TileType");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const RemoveAnyPlants_1 = require("../../deferredActions/RemoveAnyPlants");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class MetallicAsteroid extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.METALLIC_ASTEROID,
            tags: [Tags_1.Tags.SPACE],
            cost: 13,
            tr: { temperature: 1 },
            metadata: {
                cardNumber: 'A13',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.temperature(1).titanium(1).br;
                    b.minus().plants(4).digit.any;
                    b.tile(TileType_1.TileType.METALLIC_ASTEROID, false, true);
                }),
                description: 'Raise temperature 1 step and gain 1 titanium. Remove up to 4 plants from any player. Place this tile which grants an ADJACENCY BONUS of 1 titanium.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        player.titanium++;
        player.game.increaseTemperature(player, 1);
        player.game.defer(new RemoveAnyPlants_1.RemoveAnyPlants(player, 4));
        return new SelectSpace_1.SelectSpace('Select space for Metallic Asteroid tile', player.game.board.getAvailableSpacesOnLand(player), TileType_1.TileType.METALLIC_ASTEROID, (space) => {
            player.game.addTile(player, SpaceType_1.SpaceType.LAND, space, {
                tileType: TileType_1.TileType.METALLIC_ASTEROID,
                card: this.name,
            });
            space.adjacency = { bonus: [SpaceBonus_1.SpaceBonus.TITANIUM] };
            return undefined;
        });
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromTemperatureIncrease(1) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, temperatureIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.MetallicAsteroid = MetallicAsteroid;
//# sourceMappingURL=MetallicAsteroid.js.map